import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../components/ui/select";
import { ShoppingBag } from "lucide-react";
import { toast } from "sonner";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

const STATUS = ["received", "packing", "shipped", "delivered", "cancelled"];

export default function StorefrontOrders() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("");

  const load = () => api.get("/cms/storefront-orders", { params: filter ? { status: filter } : {} }).then(r => setRows(r.data));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line

  const setStatus = async (o, v) => {
    try { await api.patch(`/cms/storefront-orders/${o.id}`, { fulfillment_status: v }); load(); toast.success("Updated"); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-5" data-testid="storefront-orders-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Storefront</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight mt-1">Online Orders</h1>
      </div>
      <Card className="p-4 flex items-center gap-3">
        <Select value={filter || "all"} onValueChange={v => setFilter(v === "all" ? "" : v)}>
          <SelectTrigger className="w-48"><SelectValue placeholder="All statuses" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            {STATUS.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
        <div className="text-sm text-muted-foreground">{rows.length} orders</div>
      </Card>
      <div className="space-y-2">
        {rows.map(o => (
          <Card key={o.id} className="p-4 flex flex-wrap items-center gap-3" data-testid={`order-${o.id}`}>
            <ShoppingBag className="w-5 h-5 text-primary" />
            <div className="flex-1 min-w-[160px]">
              <div className="font-mono font-semibold">{o.order_no}</div>
              <div className="text-xs text-muted-foreground">{new Date(o.created_at).toLocaleString()}</div>
            </div>
            <div className="text-sm">
              <div>{o.customer_name}</div>
              <div className="text-xs text-muted-foreground font-mono">{o.customer_mobile}</div>
            </div>
            <div className="text-sm">
              <div className="font-heading font-bold">{inr(o.grand_total)}</div>
              <div className="text-xs text-muted-foreground">{o.items.length} item{o.items.length === 1 ? "" : "s"} · {o.payment_method}</div>
            </div>
            <Badge variant="outline">{o.payment_status}</Badge>
            <Select value={o.fulfillment_status} onValueChange={(v) => setStatus(o, v)}>
              <SelectTrigger className="w-32 h-9"><SelectValue /></SelectTrigger>
              <SelectContent>{STATUS.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
            </Select>
          </Card>
        ))}
        {rows.length === 0 && <Card className="p-8 text-center text-muted-foreground">No storefront orders yet.</Card>}
      </div>
    </div>
  );
}
